// Central image manifest for the home page.
// Drop Rang Avdhoot Maharaj / ashram photos into src/assets/slider-img/
// and point these paths at them to swap the visuals in one place.

export const homeImages = {
  // Full-screen hero slides (Rang Avdhoot Maharaj / ashram photos)
  heroSlides: [
    require('../assets/slider-img/1.webp'),
    require('../assets/slider-img/bapji (2).webp'),
    require('../assets/slider-img/bapji (3).webp'),
  ],
  // Pujya Bapji portrait (main hero image)
  bapji: require('../assets/slider-img/bapji (1).webp'),
  // Hero cinematic portrait (Bapji 2)
  bapji2: require('../assets/slider-img/bapji (2).webp'),
  // Transparent PNG hero image (used as the main hero figure)
  heroPng: require('../assets/slider-img/318459600_229505406079636_7663349552719630546_n-removebg-preview.png'),
  // Bapji front-facing photo (premium hero portrait, black bg removed, WebP)
  bapjiFront: require('../assets/slider-img/bapjifront.webp'),
  bapjiFrontSmall: require('../assets/slider-img/bapjifront-480.webp'),
  // Welcome / "Who we are" portrait
  welcome: require('../assets/slider-img/aboutus.webp'),
  // Guru / Datt Parampara lineage image
  parampara: require('../assets/slider-img/datt-parampara.webp'),
};
